export const USER_ABORTED_UPLOAD = 'User aborted upload';

export const abortUpload = (xhrRequest: XMLHttpRequest) => {
  if (xhrRequest.readyState < 4) {
    xhrRequest.abort();
  }
};
